import React from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"
import DownloadForm from "../components/downloadForm"
import HeaderWhite from "../components/headerWhite"
import { Display, DisplaySmall, Lead } from "../components/typography"
import { Container, Row, Col } from "react-grid-system"

const Download = () => {
  return (
    <Layout>
      <SEO title="Scarica la guida" />
      <HeaderWhite />
      <CustomContainer>
        <Row justify="center">
          <Col xs={12} sm={12} md={12} lg={12}>
            <Display align="center">Scarica la guida</Display>
            <Lead align="center">
              Compila la form per scaricare gratuitamente la guida MULTI alla
              CSR!
            </Lead>
          </Col>
        </Row>
        <Row justify="center">
          <Col xs={12} sm={12} md={9} lg={6}>
            <DownloadForm />
          </Col>
        </Row>
      </CustomContainer>
    </Layout>
  )
}

const CustomContainer = styled(Container)`
  margin-top: 4rem;
  h1 {
    margin-bottom: 1rem;
  }
  & > * {
    margin-bottom: 4rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export default Download
